import React, { useState, useEffect, useCallback } from 'react';
import { Button, Table, Modal, Form, Spinner, Alert } from 'react-bootstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Select from 'react-select';
import FixRequiredSelect from '../../components/sis/modalcliente/FixRequiredSelect';
import { getAllPaciente } from '../../../api/pacienteApi';
import { getAllUsuario, getUserCredentials } from '../../../api/usuarioApi';
import { getAdminById } from '../../../api/AdminApi';
import { getgastosbyliquidacion, AddGasto, EditGasto, deleteGasto } from '../../../api/marcacionApi';
import { getAllCajaEntrada, getAllCajaSalida } from '../../../api/InventarioApi';
import { canAccess, canDownloadExcel } from '../../../utils/permissions';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';

const Gastos = ({ metodo = 'OPERATIVA' }) => {
  const [showGastoModal, setShowGastoModal] = useState(false);
  const [gastos, setGastos] = useState([]);
  const [filteredGastos, setFilteredGastos] = useState([]);
  const [pacientes, setPacientes] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [productosInventario, setProductosInventario] = useState([]);
  const [esGastoProducto, setEsGastoProducto] = useState(false);
  const [productoRows, setProductoRows] = useState([{ producto: null, cantidad: '1' }]);
  const [canShowMontoProducto, setCanShowMontoProducto] = useState(false);
  const [canExportExcel, setCanExportExcel] = useState(false);
  const [isEditingGasto, setIsEditingGasto] = useState(false);
  const [currentGasto, setCurrentGasto] = useState(null);
  const [loadingStates, setLoadingStates] = useState({
    fetchingGastos: false,
    addingGasto: false,
    editingGasto: false,
    deletingGasto: false,
    fetchingGastoModalData: false,
    fetchingInventario: false,
  });
  const [formData, setFormData] = useState({
    gasto: '',
    monto: '',
    paraTarifa: true,
    paraHonorario: true,
    fecha: '',
    hora: '',
    factura: '',
  });
  const [formData3, setFormData3] = useState({});
  const [errors, setErrors] = useState({});
  const [filterData, setFilterData] = useState({
    fecha: '',
    idPaciente: null,
  });

  const isProductoGasto = (gasto) =>
    gasto?.esProducto === true ||
    String(gasto?.esProducto || '').toLowerCase() === 'true' ||
    /\s+x\s*\d+([,.]\d+)?\s*$/i.test(String(gasto?.gasto || ''));

  const setLoading = (key, value) => {
    setLoadingStates((prev) => ({ ...prev, [key]: value }));
  };

  const fetchPacientes = useCallback(async () => {
    try {
      const response = await getAllPaciente();
      setPacientes(response);
    } catch (error) {
      console.error('Error fetching pacientes:', error);
    }
  }, []);

  const fetchUsuarios = useCallback(async () => {
    try {
      const response = await getAllUsuario();
      const filteredUsuarios = response.filter((user) => user.estaActivo !== 'Inactivo');
      setUsuarios(filteredUsuarios);
    } catch (error) {
      console.error('Error fetching usuarios:', error);
    }
  }, []);

  const fetchMontoPermission = useCallback(async () => {
    try {
      const resultUser = await getUserCredentials();
      const userData = await getAdminById(resultUser.IdUsuario);
      setCanShowMontoProducto(canAccess(userData?.[0], 'cierres'));
      setCanExportExcel(canDownloadExcel(userData?.[0]));
    } catch (error) {
      console.error('Error checking cierres permission:', error);
      setCanShowMontoProducto(false);
      setCanExportExcel(false);
    }
  }, []);

  const getPrecioVenta = (item) => {
    const candidates = [
      item?.precioVenta,
      item?.PrecioVenta,
      item?.PRECIOVENTA,
      item?.precio_venta,
      item?.Precio_Venta,
      item?.PRECIO_VENTA,
      item?.precioventa,
      item?.precio,
      item?.Precio,
      item?.PRECIO,
      item?.precio_unitario,
      item?.precioUnitario,
      item?.PRECIO_UNITARIO,
      item?.preciofinal,
      item?.precioFinal,
      item?.PRECIOFINAL,
      item?.venta,
      item?.Venta,
      item?.VENTA,
      item?.precio_venta_unitario,
    ];
    const found = candidates.find((value) => value !== undefined && value !== null && value !== '');
    if (found === undefined) return 0;
    const normalized = String(found).replace(/\./g, '').replace(',', '.');
    const parsed = parseFloat(normalized);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const fetchProductosInventario = useCallback(async () => {
    try {
      setLoading('fetchingInventario', true);
      const [entradas, salidas] = await Promise.all([getAllCajaEntrada(), getAllCajaSalida()]);
      const stockMap = {};

      (entradas || []).forEach((item) => {
        const articulo = (item.articulo || item.producto || '').trim().toUpperCase();
        if (!articulo) return;
        if (!stockMap[articulo]) {
          stockMap[articulo] = { articulo, totalEntrada: 0, totalSalida: 0, precioVenta: 0 };
        }
        stockMap[articulo].totalEntrada += Number(item.cantidad) || 0;
        const precioVenta = getPrecioVenta(item);
        if (precioVenta > 0) stockMap[articulo].precioVenta = precioVenta;
      });

      (salidas || []).forEach((item) => {
        const articulo = (item.articulo || item.producto || '').trim().toUpperCase();
        if (!articulo) return;
        if (!stockMap[articulo]) {
          stockMap[articulo] = { articulo, totalEntrada: 0, totalSalida: 0, precioVenta: 0 };
        }
        stockMap[articulo].totalSalida += Number(item.cantidad) || 0;
      });

      const productos = Object.values(stockMap)
        .map((item) => ({ ...item, stockActual: item.totalEntrada - item.totalSalida }))
        .filter((item) => item.stockActual > 0)
        .sort((a, b) => a.articulo.localeCompare(b.articulo));

      setProductosInventario(productos);
    } catch (error) {
      console.error('Error fetching inventario:', error);
    } finally {
      setLoading('fetchingInventario', false);
    }
  }, []);

  // Trae TODO; el filtrado por metodo lo hace applyFilters
  const fetchGastos = useCallback(async () => {
    try {
      setLoading('fetchingGastos', true);
      const response = await getgastosbyliquidacion(0);
      const list = Array.isArray(response) ? response : [];
      setGastos(list);
      setFilteredGastos(list); // luego applyFilters ajusta
    } catch (error) {
      console.error('Error fetching gastos:', error);
      setErrors({ gastos: 'Error al cargar los gastos. Intente nuevamente.' });
    } finally {
      setLoading('fetchingGastos', false);
    }
  }, []);

  const handleShowGastoModal = async (gasto = null) => {
    try {
      setLoading('fetchingGastoModalData', true);
      await Promise.all([fetchPacientes(), fetchUsuarios(), fetchProductosInventario()]);
      if (gasto) {
        setIsEditingGasto(true);
        setCurrentGasto(gasto);
        setFormData({
          gasto: gasto.gasto,
          monto: formatNumber(gasto.monto),
          paraTarifa: gasto.paraTarifa === 'SI',
          paraHonorario: gasto.paraHonorario === 'SI',
          fecha: gasto.fecha,
          hora: gasto.hora,
          factura: gasto.factura || '',
        });
        setFormData3({
          idPaciente: gasto.idPaciente || 0,
          paciente: gasto.paciente || 'Otros',
          idUsuario: gasto.idUsuario || 0,
          usuario: gasto.usuario || 'Otros',
        });
        setEsGastoProducto(false);
        setProductoRows([{ producto: null, cantidad: '1' }]);
      } else {
        setIsEditingGasto(false);
        setCurrentGasto(null);
        setFormData({
          gasto: '',
          monto: '',
          paraTarifa: true,
          paraHonorario: true,
          fecha: '',
          hora: '',
          factura: '',
        });
        setFormData3({});
        setEsGastoProducto(false);
        setProductoRows([{ producto: null, cantidad: '1' }]);
      }
      setShowGastoModal(true);
    } catch (err) {
      console.error(err);
      setErrors({ submit: 'Error al cargar los datos. Intente nuevamente.' });
    } finally {
      setLoading('fetchingGastoModalData', false);
    }
  };

  const handleCloseGastoModal = () => {
    setShowGastoModal(false);
    setFormData({
      gasto: '',
      monto: '',
      paraTarifa: true,
      paraHonorario: true,
      fecha: '',
      hora: '',
      factura: '',
    });
    setFormData3({});
    setEsGastoProducto(false);
    setProductoRows([{ producto: null, cantidad: '1' }]);
    setErrors({});
    setIsEditingGasto(false);
    setCurrentGasto(null);
    setLoading('addingGasto', false);
    setLoading('editingGasto', false);
  };

  const handleDeleteGasto = async (idGasto) => {
    const result = await Swal.fire({
      title: '¿Estás seguro?',
      text: 'No podrás revertir esta acción.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
    });
    if (result.isConfirmed) {
      setLoading('deletingGasto', true);
      try {
        await deleteGasto(idGasto);
        await fetchGastos();
        Swal.fire({
          title: 'Eliminado',
          text: 'El gasto ha sido eliminado.',
          icon: 'success',
          timer: 1500,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error('Error al eliminar el gasto:', error);
        setErrors({ gastos: 'Error al eliminar el gasto. Intente nuevamente.' });
      } finally {
        setLoading('deletingGasto', false);
      }
    }
  };

  // Inputs
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === 'monto') {
      let rawValue = value.replace(/[^\d\-,.]/g, '');
      rawValue = rawValue.replace(/(?!^)-/g, '');
      setFormData((prev) => ({ ...prev, [name]: rawValue }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    }
    setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilterData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePacienteFilterChange = (selectedOption) => {
    setFilterData((prev) => ({
      ...prev,
      idPaciente: selectedOption ? selectedOption.value : null,
    }));
  };

  // Filtro centralizado
  const applyFilters = useCallback(() => {
    let filtered = gastos;
    const metodoNorm = String(metodo || '').trim().toLowerCase();

    if (metodoNorm === 'operativa') {
      filtered = filtered.filter(
        (g) => String(g?.metodo ?? '').trim().toLowerCase() === 'operativa'
      );
    } else if (metodoNorm === 'administrativo') {
      // no filtra por método → muestra todos
    } // cualquier otro valor: no filtra por método

    if (filterData.fecha) {
      filtered = filtered.filter((g) => g.fecha === filterData.fecha);
    }

    if (filterData.idPaciente !== null) {
      filtered = filtered.filter(
        (g) =>
          g.idPaciente === filterData.idPaciente ||
          (filterData.idPaciente === 0 && (!g.idPaciente || g.paciente === 'Otros'))
      );
    }

    setFilteredGastos(filtered);
  }, [gastos, filterData, metodo]);

  const validateGastoForm = () => {
    const newErrors = {};
    const hasInventoryProducts = !isEditingGasto && esGastoProducto;
    if (!hasInventoryProducts && !formData.gasto.trim()) newErrors.gasto = 'El detalle es requerido';
    const montoValue = parseFloat(formData.monto.toString().replace(/\./g, '').replace(',', '.'));
    if (!hasInventoryProducts && (!formData.monto || montoValue === 0 || isNaN(montoValue))) newErrors.monto = 'El monto no puede ser cero';
    if (hasInventoryProducts) {
      const validRows = productoRows.filter((row) => row.producto);
      if (validRows.length === 0) {
        newErrors.productosInventario = 'Agregue al menos un producto';
      } else {
        const invalidRow = validRows.find((row) => {
          const cantidad = Number(row.cantidad);
          return !row.producto || !Number.isFinite(cantidad) || cantidad <= 0 || cantidad > Number(row.producto.stockActual);
        });
        if (invalidRow) {
          newErrors.productosInventario = 'Revise producto, stock y cantidad';
        }
      }
    }
    if (!formData.fecha) newErrors.fecha = 'La fecha es requerida';
    if (!formData.hora) newErrors.hora = 'La hora es requerida';
    return newErrors;
  };

  const handleGastoSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateGastoForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(isEditingGasto ? 'editingGasto' : 'addingGasto', true);
    try {
      // Conservar método original al editar; usar el prop al crear
      const metodoToSend = isEditingGasto ? (currentGasto?.metodo ?? metodo) : metodo;
      const metodoNormalizado = String(metodoToSend).trim().toUpperCase();

      const combinedFormData = {
        idgastoenfermeria: isEditingGasto ? currentGasto.idgastoenfermeria : null,
        gasto: formData.gasto,
        idPaciente: formData3.idPaciente || 0,
        idUsuario: formData3.idUsuario || 0,
        idliquidacion: 0,
        monto: parseFloat(formData.monto.toString().replace(/\./g, '').replace(',', '.')),
        paciente: formData3.paciente || 'Otros',
        paraHonorario: formData.paraHonorario ? 'SI' : 'NO',
        paraTarifa: formData.paraTarifa ? 'SI' : 'NO',
        usuario: formData3.usuario || 'Otros',
        fecha: formData.fecha,
        hora: formData.hora,
        metodo: metodoNormalizado,
        factura: formData.factura || '',
      };

      if (isEditingGasto) {
        await EditGasto(combinedFormData);
      } else if (esGastoProducto) {
        await Promise.all(
          productoRows
            .filter((row) => row.producto)
            .map((row) => {
              const cantidad = Number(row.cantidad) || 0;
              return AddGasto({
                ...combinedFormData,
                gasto: `${row.producto.articulo} x ${cantidad}`,
                monto: (Number(row.producto.precioVenta) || 0) * cantidad,
                esProducto: true,
              });
            })
        );
      } else {
        await AddGasto(combinedFormData);
      }
      await fetchGastos();
      handleCloseGastoModal();
      Swal.fire({
        title: isEditingGasto ? 'Actualizado' : 'Agregado',
        text: `El gasto ha sido ${isEditingGasto ? 'actualizado' : 'agregado'} con éxito.`,
        icon: 'success',
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error('Error submitting gasto:', error);
      setErrors({ submit: 'Error al guardar el gasto. Intente nuevamente.' });
    } finally {
      setLoading(isEditingGasto ? 'editingGasto' : 'addingGasto', false);
    }
  };

  const formatNumber = (value) => {
    if (value === '' || value === undefined || value === null) return '';
    const num = parseFloat(value.toString().replace(/\./g, '').replace(',', '.'));
    if (isNaN(num)) return '';
    return num.toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  };

  const pacienteOptions = pacientes.map((pac) => ({
    value: pac.IdPacientes,
    label: `${pac.NombrePaciente}`,
  }));

  const usuarioOptions = usuarios.map((user) => ({
    value: user.IdUsuario,
    label: user.Usuario,
  }));

  const productoOptions = productosInventario.map((producto) => ({
    value: producto.articulo,
    label: producto.articulo,
    articulo: producto.articulo,
    precioVenta: producto.precioVenta,
    stockActual: producto.stockActual,
  }));

  const productoSelectStyles = {
    control: (base) => ({
      ...base,
      minHeight: 48,
    }),
    valueContainer: (base) => ({
      ...base,
      minHeight: 46,
      paddingTop: 6,
      paddingBottom: 6,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };

  const updateProductoRow = (index, field, value) => {
    setProductoRows((prev) => prev.map((row, rowIndex) => (
      rowIndex === index ? { ...row, [field]: value } : row
    )));
    setErrors((prev) => ({ ...prev, productosInventario: '', gasto: '', monto: '' }));
  };

  const getProductoRowMonto = (row) => {
    const cantidad = Number(row.cantidad) || 0;
    return (Number(row.producto?.precioVenta) || 0) * cantidad;
  };

  const addProductoRow = () => {
    setProductoRows((prev) => [...prev, { producto: null, cantidad: '1' }]);
  };

  const removeProductoRow = (index) => {
    setProductoRows((prev) => {
      const next = prev.filter((_, rowIndex) => rowIndex !== index);
      return next.length ? next : [{ producto: null, cantidad: '1' }];
    });
  };

  const isEditingProductoGasto = isEditingGasto && isProductoGasto(currentGasto || formData);
  const isCierresView = String(metodo).trim().toLowerCase() === 'administrativo';

  const handleExportExcel = () => {
    if (filteredGastos.length === 0) {
      Swal.fire({
        icon: 'info',
        title: 'Sin datos',
        text: 'No hay gastos para exportar con los filtros aplicados.',
      });
      return;
    }

    const rows = filteredGastos.map((gasto) => ({
      Fecha: gasto.fecha || '',
      Hora: gasto.hora || '',
      Factura: gasto.factura || '',
      Usuario: gasto.paciente || 'Otros',
      Profesional: gasto.usuario || 'Otros',
      Detalle: gasto.gasto || '',
      Monto: Number(gasto.monto) || 0,
      'Para tarifa': gasto.paraTarifa || '',
      'Para honorario': gasto.paraHonorario || '',
    }));

    const worksheet = XLSX.utils.json_to_sheet(rows);
    worksheet['!cols'] = [
      { wch: 12 },
      { wch: 10 },
      { wch: 18 },
      { wch: 28 },
      { wch: 28 },
      { wch: 55 },
      { wch: 16 },
      { wch: 14 },
      { wch: 18 },
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Gastos');

    const filtroFecha = filterData.fecha || 'todos';
    XLSX.writeFile(workbook, `Gastos_Cierres_${filtroFecha}.xlsx`);
  };

  useEffect(() => {
    fetchPacientes();
    fetchUsuarios();
    fetchGastos();
    fetchMontoPermission();
  }, [fetchPacientes, fetchUsuarios, fetchGastos, fetchMontoPermission]);

  useEffect(() => {
    applyFilters();
  }, [filterData, gastos, applyFilters]);

  return (
    <div className="card">
      <div className="card-header border-0 pb-0">
        <div className="d-flex gap-2 align-items-center">
          <Button
            variant="primary"
            size="sm"
            onClick={() => handleShowGastoModal()}
            disabled={loadingStates.addingGasto || loadingStates.fetchingGastos || loadingStates.fetchingGastoModalData}
          >
            {loadingStates.addingGasto || loadingStates.fetchingGastoModalData ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Cargando...
              </>
            ) : (
              'Agregar Gastos'
            )}
          </Button>

          {isCierresView && canExportExcel && (
            <Button
              variant="outline-success"
              size="sm"
              onClick={handleExportExcel}
              disabled={loadingStates.fetchingGastos || filteredGastos.length === 0}
            >
              Descargar Excel
            </Button>
          )}

          <Form.Group className="me-2">
            <Form.Label>Filtrar por Fecha</Form.Label>
            <Form.Control
              type="date"
              name="fecha"
              value={filterData.fecha}
              onChange={handleFilterChange}
              disabled={loadingStates.fetchingGastos}
            />
          </Form.Group>

          <Form.Group className="me-2" style={{ minWidth: '200px' }}>
            <Form.Label>Filtrar por Paciente</Form.Label>
            <FixRequiredSelect
              SelectComponent={Select}
              options={[{ label: 'Todos', value: null }, { label: 'Otros', value: 0 }, ...pacienteOptions]}
              isSearchable
              value={
                ([{ label: 'Todos', value: null }, { label: 'Otros', value: 0 }, ...pacienteOptions])
                  .find((option) => option.value === filterData.idPaciente) || { label: 'Todos', value: null }
              }
              onChange={handlePacienteFilterChange}
              placeholder="Seleccione un paciente"
              isLoading={pacientes.length === 0}
              loadingMessage={() => 'Cargando'}
              noOptionsMessage={() => 'Sin Datos'}
              isDisabled={loadingStates.fetchingGastos}
            />
          </Form.Group>
        </div>
      </div>

      <div className="card-body">
        {errors.gastos && <Alert variant="danger">{errors.gastos}</Alert>}
        {loadingStates.fetchingGastos ? (
          <div className="text-center">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Cargando...</span>
            </Spinner>
          </div>
        ) : filteredGastos.length === 0 ? (
          <p>No hay gastos que coincidan con los filtros.</p>
        ) : (
          <PerfectScrollbar>
            <table className="table verticle-middle table-responsive-md">
              <thead style={{ backgroundColor: '#304a97' }}>
                <tr>
                  <th style={{ minWidth: 130 }}>Fecha hora</th>
                  <th style={{ minWidth: 120 }}>Factura</th>
                  <th style={{ minWidth: 180 }}>Usuario</th>
                  <th style={{ minWidth: 180 }}>Prof.</th>
                  <th style={{ minWidth: 360 }}>Detalle</th>
                  <th style={{ minWidth: 100 }}>Monto</th>
                  <th style={{ minWidth: 80 }}>Opc.</th>
                </tr>
              </thead>
              <tbody>
                {filteredGastos.map((gasto, index) => (
                  <tr key={index}>
                    <td>{gasto.fecha} {gasto.hora}</td>
                    <td>{gasto.factura || '-'}</td>
                    <td>
                      <div>{gasto.paciente || 'Otros'}</div>
                    </td>
                    <td>{gasto.usuario || 'Otros'}</td>
                    <td
                      style={{
                        minWidth: '360px',
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                      }}
                    >
                      <div>{gasto.gasto}</div>
                    </td>
                    <td>{isProductoGasto(gasto) && !canShowMontoProducto ? '-' : formatNumber(gasto.monto)}</td>
                    <td>
                      <div className="d-flex justify-content-center">
                        <li
                          className="btn btn-primary shadow btn-xs sharp me-1"
                          onClick={() => handleShowGastoModal(gasto)}
                          disabled={loadingStates.editingGasto || loadingStates.deletingGasto}
                        >
                          {loadingStates.editingGasto && currentGasto?.idgastoenfermeria === gasto.idgastoenfermeria ? (
                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                          ) : (
                            <i className="fas fa-pencil-alt"></i>
                          )}
                        </li>
                        <li
                          className="btn btn-danger shadow btn-xs sharp me-1"
                          onClick={() => handleDeleteGasto(gasto.idgastoenfermeria)}
                          disabled={loadingStates.editingGasto || loadingStates.deletingGasto}
                        >
                          {loadingStates.deletingGasto && currentGasto?.idgastoenfermeria === gasto.idgastoenfermeria ? (
                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                          ) : (
                            <i className="fa fa-trash"></i>
                          )}
                        </li>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </PerfectScrollbar>
        )}
      </div>

      <Modal show={showGastoModal} onHide={handleCloseGastoModal} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>{isEditingGasto ? 'Editar Gasto' : 'Agregar Gasto'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {errors.submit && <Alert variant="danger">{errors.submit}</Alert>}
          <Form onSubmit={handleGastoSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>
                Profesional <span className="text-danger">*</span>
              </Form.Label>
              <FixRequiredSelect
                SelectComponent={Select}
                options={[{ label: 'Otros', value: 0 }, ...usuarioOptions]}
                isSearchable
                required
                value={usuarioOptions.find((option) => option.value === formData3.idUsuario) || { label: 'Otros', value: 0 }}
                onChange={(e) => {
                  setFormData3((prev) => ({ ...prev, idUsuario: e.value, usuario: e.label }));
                  setErrors((prev) => ({ ...prev, idUsuario: '' }));
                }}
                placeholder="Seleccione un profesional"
                isLoading={usuarios.length === 0}
                loadingMessage={() => 'Cargando'}
                noOptionsMessage={() => 'Sin Datos'}
                isDisabled={loadingStates.addingGasto || loadingStates.editingGasto}
              />
              {errors.idUsuario && <Form.Text className="text-danger">{errors.idUsuario}</Form.Text>}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>
                Paciente <span className="text-danger">*</span>
              </Form.Label>
              <FixRequiredSelect
                SelectComponent={Select}
                options={[{ label: 'Otros', value: 0 }, ...pacienteOptions]}
                isSearchable
                required
                value={pacienteOptions.find((option) => option.value === formData3.idPaciente) || { label: 'Otros', value: 0 }}
                onChange={(e) => {
                  setFormData3((prev) => ({ ...prev, idPaciente: e.value, paciente: e.label }));
                  setErrors((prev) => ({ ...prev, idPaciente: '' }));
                }}
                placeholder="Seleccione un paciente"
                isLoading={pacientes.length === 0}
                loadingMessage={() => 'Cargando'}
                noOptionsMessage={() => 'Sin Datos'}
                isDisabled={loadingStates.addingGasto || loadingStates.editingGasto}
              />
              {errors.idPaciente && <Form.Text className="text-danger">{errors.idPaciente}</Form.Text>}
            </Form.Group>

            <Form.Group className="mb-3" controlId="formFecha">
              <Form.Label>Fecha</Form.Label>
              <Form.Control
                type="date"
                name="fecha"
                value={formData.fecha}
                onChange={handleInputChange}
                required
                disabled={loadingStates.addingGasto || loadingStates.editingGasto}
              />
              {errors.fecha && <Form.Text className="text-danger">{errors.fecha}</Form.Text>}
            </Form.Group>

            <Form.Group className="mb-3" controlId="formHora">
              <Form.Label>Hora</Form.Label>
              <Form.Control
                type="time"
                name="hora"
                value={formData.hora}
                onChange={handleInputChange}
                required
                disabled={loadingStates.addingGasto || loadingStates.editingGasto}
              />
              {errors.hora && <Form.Text className="text-danger">{errors.hora}</Form.Text>}
            </Form.Group>

            <Form.Group className="mb-3" controlId="formFactura">
              <Form.Label>Factura</Form.Label>
              <Form.Control
                type="text"
                name="factura"
                value={formData.factura}
                onChange={handleInputChange}
                placeholder="Número / Código de factura"
                disabled={loadingStates.addingGasto || loadingStates.editingGasto}
                maxLength={50}
              />
              {errors.factura && <Form.Text className="text-danger">{errors.factura}</Form.Text>}
            </Form.Group>

            {!isEditingGasto && (
              <div className="mb-3">
                <Form.Check
                  type="checkbox"
                  id="formEsGastoProducto"
                  label="Gasto de producto"
                  checked={esGastoProducto}
                  onChange={(e) => {
                    setEsGastoProducto(e.target.checked);
                    setErrors((prev) => ({ ...prev, productosInventario: '', gasto: '', monto: '' }));
                  }}
                  disabled={loadingStates.addingGasto || loadingStates.editingGasto}
                />

                {esGastoProducto && (
                  <div className="mt-2">
                    <Table responsive className="mb-3 align-middle" style={{ tableLayout: 'fixed', minWidth: 760 }}>
                      <thead>
                        <tr>
                          <th style={{ width: '68%' }}>Producto</th>
                          <th style={{ width: 120 }}>Cantidad</th>
                          {canShowMontoProducto && <th style={{ width: 140 }}>Monto</th>}
                          <th style={{ width: 60 }}></th>
                        </tr>
                      </thead>
                      <tbody>
                        {productoRows.map((row, index) => (
                          <tr key={index} style={{ height: 72 }}>
                            <td className="py-3">
                              <FixRequiredSelect
                                SelectComponent={Select}
                                options={productoOptions}
                                isSearchable
                                value={row.producto}
                                onChange={(option) => updateProductoRow(index, 'producto', option)}
                                placeholder="Seleccione producto"
                                isLoading={loadingStates.fetchingInventario}
                                loadingMessage={() => 'Cargando inventario'}
                                noOptionsMessage={() => 'Sin productos con stock'}
                                isDisabled={loadingStates.addingGasto || loadingStates.editingGasto}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                styles={productoSelectStyles}
                              />
                            </td>
                            <td className="py-3">
                              <Form.Control
                                type="number"
                                min="1"
                                max={row.producto?.stockActual || undefined}
                                value={row.cantidad}
                                onChange={(e) => updateProductoRow(index, 'cantidad', e.target.value)}
                                disabled={loadingStates.addingGasto || loadingStates.editingGasto}
                                style={{ minHeight: 48 }}
                              />
                            </td>
                            {canShowMontoProducto && (
                              <td className="py-3 text-end">{formatNumber(getProductoRowMonto(row))}</td>
                            )}
                            <td className="py-3">
                              <Button
                                variant="outline-danger"
                                size="sm"
                                type="button"
                                onClick={() => removeProductoRow(index)}
                                disabled={loadingStates.addingGasto || loadingStates.editingGasto}
                              >
                                <i className="fa fa-trash"></i>
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <div className="d-flex justify-content-between align-items-center">
                      <Button
                        variant="outline-primary"
                        size="sm"
                        type="button"
                        onClick={addProductoRow}
                        disabled={loadingStates.addingGasto || loadingStates.editingGasto}
                      >
                        Agregar producto
                      </Button>
                    </div>
                    <small className="text-muted d-block mt-1">
                      Al guardar se crea un gasto separado por cada fila. No se descuenta del stock.
                    </small>
                  </div>
                )}
                {errors.productosInventario && <Form.Text className="text-danger d-block">{errors.productosInventario}</Form.Text>}
              </div>
            )}

            {(!esGastoProducto || isEditingGasto) && (
              <>
                <Form.Group className="mb-3" controlId="formGasto">
                  <Form.Label>Detalle</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={7}
                    name="gasto"
                    value={formData.gasto}
                    onChange={handleInputChange}
                    placeholder="Ingrese el detalle"
                    required
                    disabled={loadingStates.addingGasto || loadingStates.editingGasto}
                  />
                  {errors.gasto && <Form.Text className="text-danger">{errors.gasto}</Form.Text>}
                </Form.Group>

                {(!isEditingProductoGasto || canShowMontoProducto) && (
                  <Form.Group className="mb-3" controlId="formMonto">
                    <Form.Label>Monto</Form.Label>
                    <Form.Control
                      type="text"
                      name="monto"
                      value={formData.monto}
                      onChange={handleInputChange}
                      placeholder="Ingrese el monto (puede ser negativo)"
                      required
                      disabled={loadingStates.addingGasto || loadingStates.editingGasto}
                      inputMode="decimal"
                      pattern="^-?\\d*[.,]?\\d*$"
                    />
                    <div>
                      <small>
                        Vista previa: <strong>{formatNumber(formData.monto)}</strong>
                      </small>
                    </div>
                    {errors.monto && <Form.Text className="text-danger">{errors.monto}</Form.Text>}
                  </Form.Group>
                )}
              </>
            )}

            <Form.Group className="mb-3" controlId="formParaTarifa">
              <Form.Check
                type="checkbox"
                name="paraTarifa"
                label="Para Tarifa"
                checked={formData.paraTarifa}
                onChange={handleInputChange}
                disabled={loadingStates.addingGasto || loadingStates.editingGasto}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formParaHonorario">
              <Form.Check
                type="checkbox"
                name="paraHonorario"
                label="Para Honorario"
                checked={formData.paraHonorario}
                onChange={handleInputChange}
                disabled={loadingStates.addingGasto || loadingStates.editingGasto}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            onClick={handleCloseGastoModal}
            disabled={loadingStates.addingGasto || loadingStates.editingGasto}
          >
            Cerrar
          </Button>
          <Button
            variant="primary"
            onClick={handleGastoSubmit}
            disabled={loadingStates.addingGasto || loadingStates.editingGasto}
          >
            {loadingStates.addingGasto || loadingStates.editingGasto ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                {isEditingGasto ? 'Actualizando...' : 'Agregando...'}
              </>
            ) : (
              isEditingGasto ? 'Actualizar' : 'Agregar'
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Gastos;
